const toolbarConfig = {
  HEIGHT: 30,
  START_WIDTH: 100,
  TIME_WIDTH: 80,
  APP_WIDTH: 158
};

export default toolbarConfig;
